import { API_BASE_URL, BaseDataClient, ForecastClient } from './api';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { throwIfAlreadyLoaded } from '@core/module-import-guard';
import { environment } from '@env/environment';

const PROVIDERS = [
  { provide: API_BASE_URL, useFactory: () => environment.baseUrl },
  BaseDataClient,
  ForecastClient,
];

@NgModule({
  declarations: [],
  imports: [],
  providers: [...PROVIDERS],
})
export class ApiModule {
  constructor(@Optional() @SkipSelf() parentModule: ApiModule) {
    throwIfAlreadyLoaded(parentModule, 'ApiModule');
  }
}
